/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from '@material-ui/core';
import Permission from 'components/ValidPermission';
import { EnvironmentFields } from 'modules/environments/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import styles from './styles';
import PreparationServer from './PreparationServer';
import SupportServers from './SupportServers';

const useStyles = makeStyles(styles);

interface Props {
  environment: EnvironmentFields | null;
  setCurrentTab: React.Dispatch<React.SetStateAction<number>>;
  setPublicationTab: React.Dispatch<React.SetStateAction<string>>;
  setHighlightSection: React.Dispatch<React.SetStateAction<string>>;
}

const ServersList = ({
  environment,
  setCurrentTab,
  setPublicationTab,
  setHighlightSection,
}: Props) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.serverTables}>
      {environment?.behavior?.type !== 'micro' && (
        <>
          <Permission value="list_preparation_servers">
            <PreparationServer
              setPublicationTab={setPublicationTab}
              setCurrentTab={setCurrentTab}
              setHighlightSection={setHighlightSection}
            />
          </Permission>
        </>
      )}
      <SupportServers />
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { environmentSelected },
}: ApplicationState) => ({
  environment: environmentSelected,
});

export default connect(mapStateToProps, {})(ServersList);
